import { render, staticRenderFns } from "./PricingInfo.vue?vue&type=template&id=fee57d9c&scoped=true"
import script from "./PricingInfo.vue?vue&type=script&lang=js"
export * from "./PricingInfo.vue?vue&type=script&lang=js"
import style0 from "./PricingInfo.vue?vue&type=style&index=0&id=fee57d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee57d9c",
  null
  
)

export default component.exports